import * as React from 'react';
import { BaseComponentProps, BaseComponentState, BaseComponent } from '../base/BaseComponent';
// import { scrollToTop } from '../core/index';
import { getAjaxhelper } from 'src/utils';
export interface BaliBestBudgetHotelProps extends BaseComponentProps {
    lang: string;
    history?: History | any;
}

export interface BaliBestBudgetHotelState extends BaseComponentState {
    formSubmit: {
        name: string,
        email: string,
        phone: string,
        country: string,
        subject: string,
        msg: string,
    };
}
/*
const GMimages = {
    "satu" : [
        'https://www.balivillasandmore.com/wp-content/uploads/2018/12/Premiere-Garden-View-400x314.jpg',
        'https://www.balivillasandmore.com/wp-content/uploads/2018/12/Thalasso-Bali-23-400x314.jpg',
        'https://www.balivillasandmore.com/wp-content/uploads/2018/12/Thalasso-Bali-25-400x314.jpg',
        'https://www.balivillasandmore.com/wp-content/uploads/2018/12/Thalasso-Bali-18-400x314.jpg',
        'https://www.balivillasandmore.com/wp-content/uploads/2018/12/Thalasso-Bali-15-400x314.jpg',
        'https://www.balivillasandmore.com/wp-content/uploads/2018/12/Thalasso-Bali-12-400x314.jpg',
        'https://www.balivillasandmore.com/wp-content/uploads/2018/12/Thalasso-Bali-3-400x314.jpg',

    ]
};
*/

interface BaliBestBudgetHotelDataSt {
    imageUrl: string;
    roomName: string;
    price: number;
    curencyCode: 'USD' | 'AUD' | 'IDR';
    linkUrl: string;
}

const BaliBestBudgetHotelData: BaliBestBudgetHotelDataSt[] = [
    {
        imageUrl: 'https://storage.googleapis.com/bali-hotel-media/additional-images/hotel-images/396019/bed15.jpg',
        roomName: 'Ramada Encore Bali Seminyak',
        price: 77.71,
        curencyCode: 'AUD',
        linkUrl: 'https://balihotelsandmore.com.au/ramada-encore-bali-seminyak-396019'
    },
    {
        imageUrl: 'https://storage.googleapis.com/bali-hotel-media/hb-images/36/367203/367203a_hb_p_003.jpg',
        roomName: 'Sun Island Hotel & Spa Legian',
        price: 79.71,
        curencyCode: 'AUD',
        linkUrl: 'https://balihotelsandmore.com.au/sun-island-hotel-and-spa-legian-367203'
    },
    {
        imageUrl: 'https://storage.googleapis.com/bali-hotel-media/hb-images/48/487321/487321a_hb_ro_024.jpg',
        roomName: 'Golden Tulip Jineng Resort Bali',
        price: 77,
        curencyCode: 'AUD',
        linkUrl: 'https://balihotelsandmore.com.au/golden-tulip-jineng-resort-bali-487321'
    },
    {
        imageUrl: 'https://storage.googleapis.com/bali-hotel-media/hb-images/23/231529/231529a_hb_ro_013.jpg',
        roomName: 'Ananta Legian',
        price: 80,
        curencyCode: 'AUD',
        linkUrl: 'https://balihotelsandmore.com.au/ananta-legian-231529'
    },
    {
        imageUrl: 'https://storage.googleapis.com/bali-hotel-media/additional-images/hotel-images/71881/107386240.jpg',
        roomName: 'The Jayakarta Bali ',
        price: 130,
        curencyCode: 'AUD',
        linkUrl: 'https://balihotelsandmore.com.au/the-jayakarta-bali-71881'
    },
    {
        imageUrl: 'https://storage.googleapis.com/bali-hotel-media/additional-images/hotel-images/24422/50410969.jpg',
        roomName: 'Kuta Paradiso ',
        price: 142,
        curencyCode: 'AUD',
        linkUrl: 'https://balihotelsandmore.com.au/kuta-paradiso-24422'
    }
];
export class BaliBestBudgetHotel extends BaseComponent<BaliBestBudgetHotelProps, BaliBestBudgetHotelState> {
    constructor(props: BaliBestBudgetHotelProps) {
        super(props);
        this.state = {
            formSubmit: {
                name: '',
                email: '',
                phone: '',
                msg: '',
                country: '',
                subject: ''
            }
        };
    }

    componentDidUpdate() {
        // scrollToTop();
    }

    render() {
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        }
        let roomandrate = [];
        for (let rate of BaliBestBudgetHotelData) {
            roomandrate.push(
                <div className="col-md-4">
                    <div
                        style={{ marginBottom: 30, border: '1px #ddd solid', cursor: "pointer" }}
                        onClick={
                            () => {
                                window.open(`${rate.linkUrl}`, '_blank');
                                // window.location.href = ;
                            }
                        }
                    >
                        <div>
                            <div style={{width: '100%', height: 232, background: `url('${rate.imageUrl}')`, backgroundSize: 'cover', backgroundPosition: 'center'}}>
                                {}
                            </div>
                            
                        </div>
                        <div style={{ padding: 15, marginBottom: 35 }}>
                            <h4 style={{ fontWeight: 800, color: '#2eb7fd' }}>{rate.roomName}</h4>
                            <h3 style={{ float: 'right', fontWeight: 800, color: 'rgb(95, 73, 255)' }}>{`${rate.curencyCode} ${rate.price}`}</h3>
                            <p>
                                <a href={`${rate.linkUrl}`} className="btn btn-primary form-control" style={{float: "right"}} target="_blank" >Book Online Now</a>
                            </p>
                        </div>
                    </div>
                </div>
            );
        }
        return (
            <div style={{ paddingBottom: 20, fontSize: 14, paddingTop: 130 }}>
                <div>
                    <video
                        poster="https://storage.googleapis.com/balivillasandmore/video/best-budget-villas-in-bali-cover.jpg"
                        loop={true}
                        controls={true}
                        width="100%"
                        height="auto"
                    >
                        <source src="https://storage.googleapis.com/balivillasandmore/video/best-budget-villas-in-bali-video.mp4" type="video/mp4" />
                        Your browser doesn’t support HTML5 video. Here is<br /> a <a href="https://storage.googleapis.com/balivillasandmore/video/best-budget-villas-in-bali-video.mp4">link to the video</a> instead.
                    </video>
                </div>

                <div style={{ padding: '20px', background: `url("https://storage.googleapis.com/bali-hotel-images/grand-mirage-spacer-1.jpg")`, backgroundSize: 'cover', backgroundPosition: 'center' }} >
                    <h2 style={{ textAlign: 'center', fontWeight: 800 }}>Bali Holidays And More Offers The Very Best Villa And Hotels Deals In Bali</h2>
                    
                </div>
                <div className="container">
                    <div className="col-md-6 col-md-push-6" style={{ marginTop: 30, marginBottom: 20 }}>
                        <h3>Best Budget Hotels in Bali</h3>
                    <p>If it’s a cheap Bali villa in Kuta you want, it’s one you will find. Villa de Daun is “Kuta’s Little Secret”, so shh, don’t tell anyone okay. Set in the heart of Kuta, this complex of 12 private villas provides a tranquil sanctuary ideal for pure relaxation after a day of surfing and shopping.</p>
                    <p>You can choose between 1 to 3 bedroom villas, with or without private pools, but you don’t get the choice of opting out on the amazing and talented villa staff. Being on a budget doesn’t mean you don’t deserve to get pampered! Traditional Balinese pavilions, lavish outdoor bathtubs and a distinctly ethnic interior design unfold the beauty and charm of tropical island architecture fused with modern comforts.</p>
                    <p>Dala Spa is connected to Villa de Daun and provides phenomenal massage treatments, and its convenient proximity saves you the time and distance in searching for another one of the million spas in Bali.</p>
                    </div>
                    <div className="col-md-6  col-md-pull-6">
                        <img src="https://storage.googleapis.com/bali-hotel-images/best-budget-hotel-in-bali/best-budget-hotels-in-bali-main.jpg" width='100%' />
                    </div>
                </div>
                <div className="container">
                    <div className="col-md-6 " style={{ marginTop: 30, marginBottom: 20 }}>
                        <h3>Things To Do In Bali</h3>
                        <p>Bali, Island of The Gods. When it comes to giving recommendations of what to when you’re here, the hardest part is narrowing the list down – there’s always something new to do and see. As a starting point though we’ve crammed as much of what this great island has to offer as we can into a Top Ten things to do in bali. So, in no particular order, read on to get some inspiration for your Bali holiday.</p>
                        <p>With so many great things to do in Bali, it can be hard to decide what to do and trying to organise everything a little daunting for some. Don’t worry; we can take care of that for you as well. If you know what you want to do, just let us know and we can have your arrangements made and tickets waiting at your villa on your arrival. If you’re not sure, check out this page or ask us for some ideas, we’d love to help.</p>
                        <a href="#frmSumbit" style={{ float: "right" }} className="btn btn-primary">Enquire Now</a>
                    </div>
                    <div className="col-md-6 ">
                        <img src="https://storage.googleapis.com/bali-hotel-images/best-budget-hotel-in-bali/budget-hotels-things-to-do-in-bali.gif" width='100%' />
                    </div>
                </div>
                <div className="container">
                    <div className="col-md-6 col-md-push-6" style={{ marginTop: 30, marginBottom: 20 }}>
                        <h3>Adventurous Bali Activities</h3>
                        <p>With pristine beaches, lush landscapes, luxurious accommodation and and a fascinating culture, Bali is a spot to unwind and rejuvenate. However, this heaven isn’t just for people who need to take a step back and relax.</p>
                        <p>If you’re daring and love the outside, why not challenge yourself with some adrenaline pumping action? There’s more to Bali than surfing when it comes to adventure.</p>
                        <p>On land or in the water, here’s a run down of some of the best adventure sports activities in Bali!</p>
                        <p><a href="https://www.balitoursandmore.com" target="_blank" rel="noopener noreferrer">Click here for more information.</a></p>
                        <a href="#frmSumbit" className="btn btn-primary">Enquire Now</a>
                    </div>
                    <div className="col-md-6  col-md-pull-6">
                        <img src="https://storage.googleapis.com/bali-hotel-images/best-budget-hotel-in-bali/budget-hotels-adventurous-bali-actifity.gif" width='100%' />
                    </div>
                </div>
                <div className="container">
                    <div className="col-md-6 " style={{ marginTop: 30, marginBottom: 20 }}>
                        <h3>Get More With Every Booking</h3>
                        <p>When you book for your villa or hotel with us you get more than just a great price on a room. You get a holiday experience you wont forget. You see the difference is we live here in Bali so we have collected some of the best deals and offers not only on your accommodation but everything you do when you arrive. From free drinks, meals discounts, spa and salon discounts, free airport transfers, free tours for kids and so much more.</p>
                        <p>Let us make your Bali holiday the best possible experience. Who knows more about Bali than the people that live here! We cant wait for you to arrive! We’ll save you!</p>
                        <p><a href="https://www.baliholidaysandmorevip.com" target="_blank" rel="noopener noreferrer">Click here for more information.</a></p>
<a href="#frmSumbit" style={{ float: "right" }} className="btn btn-primary">Enquire Now</a>
                    </div>
                    <div className="col-md-6 ">
                        <img src="https://storage.googleapis.com/bali-hotel-images/best-budget-hotel-in-bali/budget-hotels-get-more-with-every-booking.gif" width='100%' />
                    </div>
                </div> 

                <div id='frmSumbit' style={{ padding: '20px', background: `url("https://storage.googleapis.com/bali-hotel-images/bali-dynasty-special-offer.jpg")`, backgroundSize: 'cover', backgroundPosition: 'center' }} >
                    <div className='container'>
                        <div className="col-md-6 " style={{ marginTop: 30 }}>
                            <div>
                                <form id="contactForm" onSubmit={this.formSubmit} style={{ maxWidth: 600, margin: 'auto', padding: 20, background: '#ffffffa8' }}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <h3 style={{ color: 'rgb(43, 40, 74)', fontWeight: 800 }}>Send Us An Enquiry</h3>
                                            <p style={{ color: 'rgb(43, 40, 74)' }}>Fields marked with an <span className="symbol required" /> are required</p>
                                        </div>
                                        <div className="form-group">
                                            <div className="col-md-6">
                                                <label style={{ color: 'rgb(43, 40, 74)', textAlign: 'left' }}> Your name <span className="symbol required" /> </label>
                                                <input
                                                    required={true}
                                                    type="text"
                                                    className="form-control"
                                                    value={this.state.formSubmit.name}
                                                    onChange={
                                                        (evt: any) => {
                                                            let formSubmit = this.state.formSubmit;
                                                            formSubmit.name = evt.target.value;
                                                            this.setState({ formSubmit });
                                                        }

                                                    }
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label style={{ color: 'rgb(43, 40, 74)', textAlign: 'left' }}> Email address <span className="symbol required" /> </label>
                                                <input
                                                    required={true}
                                                    type="email"
                                                    className="form-control"
                                                    value={this.state.formSubmit.email}
                                                    onChange={
                                                        (evt: any) => {
                                                            let formSubmit = this.state.formSubmit;
                                                            formSubmit.email = evt.target.value;
                                                            this.setState({ formSubmit });
                                                        }
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                    <div className="row">
                                        <div className="form-group">
                                            <div className="col-md-6">
                                                <label style={{ color: 'rgb(43, 40, 74)', textAlign: 'left' }}> Phone / Whatsapp </label>
                                                <input
                                                    required={true}
                                                    type="text"
                                                    data-msg-required="Please enter phone number."
                                                    className="form-control"
                                                    value={this.state.formSubmit.phone}
                                                    onChange={
                                                        (evt: any) => {
                                                            let formSubmit = this.state.formSubmit;
                                                            formSubmit.phone = evt.target.value;
                                                            this.setState({ formSubmit });
                                                        }
                                                    }
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label style={{ color: 'rgb(43, 40, 74)', textAlign: 'left' }}> Country <span className="symbol required" /> </label>
                                                <input
                                                    required={true}
                                                    type="text"
                                                    className="form-control"
                                                    value={this.state.formSubmit.country}
                                                    onChange={
                                                        (evt: any) => {
                                                            let formSubmit = this.state.formSubmit;
                                                            formSubmit.country = evt.target.value;
                                                            this.setState({ formSubmit });
                                                        }
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                    <div className="row">
                                        <div className="form-group">
                                            <div className="col-md-12">
                                                <label style={{ color: 'rgb(43, 40, 74)', textAlign: 'left' }}> Subject <span className="symbol required" /> </label>
                                                <input
                                                    required={true}
                                                    type="text"
                                                    className="form-control"
                                                    value={this.state.formSubmit.subject}
                                                    onChange={
                                                        (evt: any) => {
                                                            let formSubmit = this.state.formSubmit;
                                                            formSubmit.subject = evt.target.value;
                                                            this.setState({ formSubmit });
                                                        }
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                    <div className="row">
                                        <div className="form-group">
                                            <div className="col-md-12">
                                                <label style={{ color: 'rgb(43, 40, 74)', textAlign: 'left' }}> Message <span className="symbol required" /> </label>
                                                <textarea
                                                    required={true}
                                                    data-msg-required="Please enter your message."
                                                    className="form-control"
                                                    rows={5}
                                                    value={this.state.formSubmit.msg}
                                                    onChange={
                                                        (evt: any) => {
                                                            let formSubmit = this.state.formSubmit;
                                                            formSubmit.msg = evt.target.value;
                                                            this.setState({ formSubmit });
                                                        }
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <button data-caption-delay="900" type="submit" data-caption-class="fadeIn" className="btn btn-primary margin-top-15 opacity-0 btn-wide btn-scroll btn-scroll-top fa-arrow-right animated fadeIn" >
                                                <span>Enquire Now</span>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container" style={{ marginTop: 30 }}>
                    <h3 style={{ textAlign: 'center' }}>Rooms & Suites</h3>
                    {roomandrate}
                </div>
            </div>

        );

    }

    formSubmit = (event: any) => {
        event.preventDefault();
        let nameSender = this.state.formSubmit.name;
        let contentClient = "";
        contentClient = "<h3>Thank you for booking your Bali hotel with Bali Hotels and More!</h3>";
        contentClient += `<p>You&rsquo;ve made a great choice; we&rsquo;re with you every step of the way to ensure hassle free holiday planning and that you have a great time in Bali. You&rsquo;ve chosen the Book Now and Pay Later option - this is a great way of making your holiday more affordable. You&rsquo;ll avoid the hidden costs of banking fees and poor currency exchange rates which you can add 5 - 10% to the cost of your accommodation when you pay with your card at the hotel. The Book Now and Pay Monthly option which you&rsquo;ve chosen includes a $1 deposit and then final payment is due 2 weeks prior to arrival in Bali or before the cancellation date of the hotel you have chosen Full terms and conditions are here &nbsp;<a href="https://www.balihotelsandmore.com.au/terms-of-use" target="_blank">https://www.balihotelsandmore.com.au/terms-of-use</a></p>`;
        contentClient += "<p>Our team will now check to ensure we have the option available for the room you want. We will then give you a quick call to confirm your exact requirements. Then we send an invoice for $1 deposit. Once you pay then we then issue and email your hotel vouchers.</p>";
        contentClient += "<p>We would also like to take this opportunity to thank you on behalf of our Bali charities we support including:</p>";
        contentClient += `<p>Soleman Bali - &nbsp;<a href="https://www.solemen.org/">https://www.solemen.org</a> &nbsp;</p>`;
        contentClient += `<p>Stella&rsquo;s Child - <a href="https://www.stellaschild.org/">https://www.stellaschild.org/</a></p>`;
        contentClient += "<p>Your booking really does make a difference here in Bali!</p>";
        contentClient += "<p>We look forward to speaking to you within the next 24 - 48 hours.</p>";
        let contentAdmin = "";
        contentAdmin += `Name : ${this.state.formSubmit.name} <br>`;
        contentAdmin += `email : ${this.state.formSubmit.email} <br>`;
        contentAdmin += `country : ${this.state.formSubmit.country} <br>`;
        contentAdmin += `phoneNumber : ${this.state.formSubmit.phone} <br>`;
        contentAdmin += `Subject : ${this.state.formSubmit.subject} <br><br><br>`;
        contentAdmin += `message : ${this.state.formSubmit.msg} <br><br><br>`;
        contentAdmin += `URL : https://balihotelsandmore.com.au/best-budget-hotel-in-bali<br><br>`;
        let subject = "[Bali Hotels and More] Best Budget Hotel in Bali " + `${this.state.formSubmit.subject}`;
        let emailSender = this.state.formSubmit.email;

        let dataSendEmail = {
            nameSender: nameSender,
            contentClient: (contentClient),
            contentAdmin: (contentAdmin),
            emailSender: emailSender,
            subject: subject
        };
        getAjaxhelper().post("/dynamics/email-sender-bham/enquery", dataSendEmail).then(
            x => {
                this.props.history.push('/settlement-thankyou');
            }
        ).catch(
            exc => {
                console.log(exc);
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/static-content/BaliBestBudgetHotel.tsx